import { CategoriesIcon } from "src/icons/CategoriesIcon";
import { BrandsIcon } from "src/icons/BrandsIcon";
import { ColoursIcon } from "src/icons/ColoursIcon";
import { PriceIcon } from "src/icons/PriceIcon";
import { SizeIcon } from "src/icons/SizeIcon";
import { PatternIcon } from "src/icons/PatternIcon";
import { StyleIcon } from "src/icons/StyleIcon";
import { GoodOnYouIcon } from "src/icons/GoodOnYouIcon";
import { Discount } from "src/icons";
import {
  BRAND_FACET,
  SIZE_FACET,
  PRICE_FACET,
  COLOUR_FACET,
  PATTERN_FACET,
  STYLE_FACET,
  CONSCIOUS_FACET,
  CATEGORIES_FACET,
  DISCOUNT_FACET,
} from "src/utils/algolia";
import { msg } from "@lingui/macro";

const availableFiltersList = [
  {
    name: msg`Categories`,
    facet: CATEGORIES_FACET,
    icon: <CategoriesIcon />,
    type: "categories",
    isMultiColumn: false,
  },
  {
    name: msg`Brands`,
    facet: BRAND_FACET,
    icon: <BrandsIcon />,
    type: "brands",
    isMultiColumn: false,
  },
  {
    name: msg`Size`,
    facet: SIZE_FACET,
    icon: <SizeIcon />,
    type: "multi-select",
    isMultiColumn: true,
  },
  {
    name: msg`Price range`,
    facet: PRICE_FACET,
    icon: <PriceIcon />,
    type: "range",
  },
  {
    name: msg`Colours`,
    facet: COLOUR_FACET,
    icon: <ColoursIcon />,
    type: "color",
    isMultiColumn: true,
  },
  {
    name: msg`Pattern`,
    facet: PATTERN_FACET,
    icon: <PatternIcon />,
    type: "multi-select",
    isMultiColumn: true,
  },
  {
    name: msg`Style`,
    facet: STYLE_FACET,
    icon: <StyleIcon />,
    type: "multi-select",
    isMultiColumn: true,
  },
  {
    name: msg`Ethically rated`,
    facet: CONSCIOUS_FACET,
    icon: <GoodOnYouIcon />,
    type: "multi-select",
    isMultiColumn: false,
  },
  {
    name: msg`Discount`,
    facet: DISCOUNT_FACET,
    icon: <Discount />,
    type: "select",
    isMultiColumn: false,
  },
];

export { availableFiltersList };
